import { render, staticRenderFns } from "./AddFeatureUpdate.vue?vue&type=template&id=634c8fac&"
import script from "./AddFeatureUpdate.vue?vue&type=script&lang=js&"
export * from "./AddFeatureUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports